import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.step-slider' ).each( function( index, element ) {
        const textSliderEl = element.querySelector( '.steps-slider__splide-main' );
        const imageSliderEl = element.querySelector( '.steps-slider__splide' );

        if ( !textSliderEl || !imageSliderEl ) return;

        const textSlider = new Splide( textSliderEl, {
          type: 'fade',
          rewind: true,
          pagination: false,
          arrows: true,
          drag: false,
          speed: 600,
        } );

        const imageSlider = new Splide( imageSliderEl, {
          type: 'fade',
          rewind: true,
          pagination: false,
          arrows: false,
          drag: false,
          speed: 600,
        } );

        textSlider.sync( imageSlider );

        textSlider.mount();
        imageSlider.mount();
      } );
    },
  };

  app.registerComponent( 'step-slider', COMPONENT );
} )( app );
